// extracted by mini-css-extract-plugin
export var button = "Content-module--button--d473a";
export var container = "Content-module--container--fbf58";
export var fadeInAnimation = "Content-module--fadeInAnimation--aa685";
export var subtitle = "Content-module--subtitle--74c21";
export var title = "Content-module--title--08da8";
export var wrapper = "Content-module--wrapper--62e13";